import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import businessFlowsTheme from "../../theme/businessFlowsTheme";
import "../auth/auth.css";

// Shell for signed-in content pages: theme, font scope, page title and a
// width-limited column that scrolls inside the app's content area.
export default function AppPage({ title, description, actions, maxWidth = 1120, children }) {
  return (
    <ThemeProvider theme={businessFlowsTheme}>
      <Box className="bfx" sx={{ bgcolor: "background.default", minHeight: "100%", boxSizing: "border-box" }}>
        <Box sx={{ maxWidth, mx: "auto", px: { xs: 2, sm: 3, md: 4 }, py: { xs: 2, md: 3 } }}>
          {(title || actions) && (
            <Box
              sx={{
                display: "flex",
                alignItems: { xs: "flex-start", sm: "flex-end" },
                justifyContent: "space-between",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
                mb: { xs: 2.5, md: 3.5 },
              }}
            >
              <Box sx={{ minWidth: 0 }}>
                {title && (
                  <Typography variant="h4" component="h1" sx={{ fontSize: { xs: "1.6rem", md: "2rem" } }}>
                    {title}
                  </Typography>
                )}
                {description && (
                  <Typography color="text.secondary" sx={{ mt: 0.5 }}>
                    {description}
                  </Typography>
                )}
              </Box>
              {actions && <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>{actions}</Box>}
            </Box>
          )}
          {children}
        </Box>
      </Box>
    </ThemeProvider>
  );
}
